import { Canvas, Point } from 'fabric';

import { MAX_ZOOM, MIN_ZOOM } from '../draw-canvas.constants';

export function handleMouseWheelEvent({
  opt,
  canvas,
  setZoomState,
}: {
  opt: any;
  canvas: Canvas;
  setZoomState: (zoom: number) => void;
}) {
  opt.e.preventDefault();
  opt.e.stopPropagation();

  const evt = opt.e as WheelEvent;
  if (evt.ctrlKey) {
    let zoom = canvas.getZoom();
    zoom *= 0.99 ** evt.deltaY;

    if (zoom > MAX_ZOOM) zoom = MAX_ZOOM;
    if (zoom < MIN_ZOOM) zoom = MIN_ZOOM;

    canvas.zoomToPoint(new Point(evt.offsetX, evt.offsetY), zoom);
    setZoomState(zoom);
  } else if (canvas.viewportTransform) {
    canvas.viewportTransform[4] += evt.deltaX * -1;
    canvas.viewportTransform[5] += evt.deltaY * -1;

    if (canvas.getActiveObject()) {
      canvas.discardActiveObject();
    }

    canvas.requestRenderAll();
  }
}
